// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAddUserOutlinedSvg from "@fishx/icons-svg/es/asn/PAddUserOutlined";
import FishxIcon from '../components/FishxIcon';

var PAddUserOutlined = function PAddUserOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAddUserOutlinedSvg
  }));
};

PAddUserOutlined.displayName = 'PAddUserOutlined';
export default React.forwardRef(PAddUserOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAddUserOutlined.js
// module id = 3198
// module chunks = 0